(function () {
  'use strict';

  var PHOTO_RECOMMENDED = {
    defect: true,
    damaged_shipping: true,
    wrong_item: true,
    not_as_described: true,
  };

  var ORDINARY_WITHDRAWAL_REASONS = {
    withdrawal_no_reason: true,
    size_too_small: true,
    size_too_large: true,
    no_longer_needed: true,
  };

  var COMPLAINT_REASONS = {
    defect: true,
    damaged_shipping: true,
    wrong_item: true,
    not_as_described: true,
  };

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function setStatus(node, kind, message) {
    node.className = 'sawdr__status' + (kind ? ' is-' + kind : '');
    node.textContent = message || '';
  }

  function formatEuroFromCents(cents) {
    return (Number(cents) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function api(root, body) {
    var url = root.getAttribute('data-sawdr-url');
    if (!url) return Promise.reject(new Error('Widerrufsfunktion ist nicht konfiguriert.'));
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || !payload.success) {
          var error = new Error(payload.error || 'Widerruf konnte nicht verarbeitet werden.');
          error.data = payload.data;
          throw error;
        }
        return payload.data;
      });
    });
  }

  function readPhotosAsBase64(fileList) {
    var files = Array.prototype.slice.call(fileList || []).slice(0, 3);
    return Promise.all(
      files.map(function (file) {
        return new Promise(function (resolve, reject) {
          if (!/^image\/(jpeg|png|webp)$/i.test(file.type)) {
            reject(new Error('Fotos müssen JPEG, PNG oder WebP sein.'));
            return;
          }
          if (file.size > 5 * 1024 * 1024) {
            reject(new Error('Jedes Foto maximal 5 MB.'));
            return;
          }
          var reader = new FileReader();
          reader.onload = function () {
            var result = String(reader.result || '');
            var comma = result.indexOf(',');
            resolve({
              mime: file.type,
              dataBase64: comma >= 0 ? result.slice(comma + 1) : result,
            });
          };
          reader.onerror = function () {
            reject(new Error('Foto konnte nicht gelesen werden.'));
          };
          reader.readAsDataURL(file);
        });
      })
    );
  }

  function setup(root) {
    var lookup = root.querySelector('[data-sawdr-lookup]');
    var selection = root.querySelector('[data-sawdr-selection]');
    var confirmation = root.querySelector('[data-sawdr-confirmation]');
    var status = root.querySelector('[data-sawdr-status]');
    var linesBox = root.querySelector('[data-sawdr-lines]');
    var confirmForm = root.querySelector('[data-sawdr-confirm-form]');
    var photosBox = root.querySelector('[data-sawdr-photos]');
    var photoInput = root.querySelector('[data-sawdr-photo-input]');
    var cashbackHint = root.querySelector('[data-sawdr-cashback-hint]');
    var labelTerms = root.querySelector('[data-sawdr-label-terms]');
    var labelTermsInput = root.querySelector('[data-sawdr-label-terms-input]');
    var labelPrice = root.querySelector('[data-sawdr-label-price]');
    var query = new URLSearchParams(window.location.search);
    var emailInput = lookup.querySelector('[name="email"]');
    var orderInput = lookup.querySelector('[name="orderNumber"]');
    emailInput.value = query.get('email') || '';
    orderInput.value = query.get('order') || '';
    var checkedOrder = null;
    var infoCashbackCents = 50;

    function selectedReasonId() {
      var checked = confirmForm.querySelector('input[name="reasonId"]:checked');
      return checked ? String(checked.value) : '';
    }

    function syncPhotoUi() {
      var reasonId = selectedReasonId();
      var recommended = !!PHOTO_RECOMMENDED[reasonId];
      photosBox.hidden = !recommended;
      if (!recommended && photoInput) photoInput.value = '';
    }

    function syncLabelTermsUi() {
      var complaint = !!COMPLAINT_REASONS[selectedReasonId()];
      var unshipped = !!(checkedOrder && checkedOrder.shipmentState === 'unshipped');
      var available = !!(
        checkedOrder &&
        checkedOrder.automaticLabel &&
        checkedOrder.automaticLabel.available
      );
      if (labelTerms) labelTerms.hidden = complaint || unshipped;
      if (labelTermsInput) {
        labelTermsInput.required = !complaint && !unshipped;
        labelTermsInput.disabled = complaint || unshipped || !available;
        if (complaint || unshipped) labelTermsInput.checked = false;
      }
      if (labelPrice) {
        labelPrice.textContent = available
          ? formatEuroFromCents(checkedOrder.automaticLabel.grossCents)
          : 'derzeit nicht verfügbar';
      }
      return complaint || unshipped || available;
    }

    function syncLineEligibility() {
      var complaint = !!COMPLAINT_REASONS[selectedReasonId()];
      var selectableCount = 0;
      linesBox.querySelectorAll('input[name="lineId"]').forEach(function (input) {
        var personalized = input.getAttribute('data-personalized') === '1';
        var disabled = personalized && !complaint;
        input.disabled = disabled;
        if (disabled) input.checked = false;
        if (!disabled) selectableCount++;
        var card = input.closest('.sawdr__line');
        if (card) card.classList.toggle('is-excluded', disabled);
        var reason = card && card.querySelector('[data-sawdr-line-reason]');
        if (reason && personalized) {
          reason.textContent = complaint
            ? 'Personalisierte Ware: für diese Reklamation auswählbar; Gewährleistungsrechte bleiben unberührt.'
            : 'Individuell angefertigt: vom normalen Widerruf grundsätzlich ausgeschlossen; bei Mangel bitte Reklamationsgrund wählen.';
        }
      });
      var submit = confirmForm.querySelector('button[type="submit"]');
      if (submit) submit.disabled = selectableCount === 0 || !syncLabelTermsUi();
    }

    function syncWithdrawalWindow(windowInfo) {
      var expired = windowInfo && windowInfo.status === 'expired';
      confirmForm.querySelectorAll('input[name="reasonId"]').forEach(function (input) {
        var ordinary = !!ORDINARY_WITHDRAWAL_REASONS[String(input.value || '')];
        input.disabled = expired && ordinary;
        if (input.disabled) input.checked = false;
      });
      syncLineEligibility();
      syncPhotoUi();
      syncLabelTermsUi();
    }

    confirmForm.querySelectorAll('input[name="reasonId"]').forEach(function (input) {
      input.addEventListener('change', function () {
        syncLineEligibility();
        syncPhotoUi();
        syncLabelTermsUi();
      });
    });

    function showCheckedOrder(data, secureResume) {
      checkedOrder = data;
      syncWithdrawalWindow(data.withdrawalWindow);
      if (data.infoCashbackCents) infoCashbackCents = Number(data.infoCashbackCents) || 50;
      if (cashbackHint) {
        cashbackHint.textContent =
          'Wenn Sie freiwillig einen Rückgabegrund angeben, hinterlegen wir als Dankeschön ' +
          formatEuroFromCents(infoCashbackCents) +
          ' Treue-Cashback auf Ihrem Kundenkonto (einmaliger Code per E-Mail).';
      }
      linesBox.textContent = '';
      var eligibleCount = 0;
      data.lines.forEach(function (line) {
        var card = el('label', 'sawdr__line' + (line.eligible ? '' : ' is-excluded'));
        var checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.name = 'lineId';
        checkbox.value = line.id;
        checkbox.setAttribute('data-personalized', line.personalized ? '1' : '0');
        checkbox.disabled = !line.eligible;
        checkbox.checked = line.eligible;
        if (line.eligible) eligibleCount++;
        var body = el('span', 'sawdr__line-body');
        body.appendChild(el('strong', null, line.quantity + '× ' + line.title));
        var lineReason = el('small', null, line.reason);
        lineReason.setAttribute('data-sawdr-line-reason', '1');
        body.appendChild(lineReason);
        card.appendChild(checkbox);
        card.appendChild(body);
        linesBox.appendChild(card);
      });
      lookup.hidden = !!secureResume;
      selection.hidden = false;
      confirmation.hidden = true;
      syncLineEligibility();
      syncPhotoUi();
      if (
        !(data.automaticLabel && data.automaticLabel.available) &&
        data.shipmentState !== 'unshipped' &&
        !(data.withdrawalWindow && data.withdrawalWindow.status === 'expired')
      ) {
        confirmForm.querySelector('button[type="submit"]').disabled = true;
        setStatus(
          status,
          'warn',
          'Der konkrete DHL-Retourentarif ist momentan nicht verfügbar. Ein Widerruf ist weiterhin per E-Mail an info@strongant.de oder per Brief möglich; Reklamationen können Sie hier trotzdem melden.'
        );
      } else if (!eligibleCount) {
        confirmForm.querySelector('button[type="submit"]').disabled = true;
        setStatus(
          status,
          'warn',
          'Diese Bestellung enthält keine online widerrufsfähige Standardposition. Personalisierte Ware kann bei einem Mangel, einer Falschlieferung, einem Transportschaden oder einer Beschreibungsabweichung hier trotzdem reklamiert werden.'
        );
      } else if (data.shipmentState === 'unshipped') {
        confirmForm.querySelector('button[type="submit"]').disabled = false;
        setStatus(
          status,
          'ok',
          'Die Bestellung wurde noch nicht versendet. Mit dem Absenden wird sie sofort für den Versand gesperrt; eine Rücksendung und ein Retourenlabel sind nicht erforderlich.'
        );
      } else if (data.withdrawalWindow && data.withdrawalWindow.status === 'expired') {
        confirmForm.querySelector('button[type="submit"]').disabled = false;
        setStatus(
          status,
          'warn',
          'Die gesetzliche Widerrufsfrist von 14 Tagen ist abgelaufen. Eine freiwillige Rückgabe bieten wir nicht an. Sie können den Vorgang fortsetzen, wenn ein Mangel, eine Falschlieferung, ein Transportschaden oder eine Abweichung von der Beschreibung vorliegt.'
        );
      } else if (data.withdrawalWindow && data.withdrawalWindow.status === 'manual_review') {
        confirmForm.querySelector('button[type="submit"]').disabled = false;
        setStatus(
          status,
          'warn',
          'Das Zustelldatum konnte nicht automatisch bestätigt werden. Ihre Erklärung kann trotzdem übermittelt werden und wird vor dem Rückversand manuell geprüft.'
        );
      } else {
        confirmForm.querySelector('button[type="submit"]').disabled = false;
        setStatus(
          status,
          'ok',
          secureResume
            ? 'Bestellung ' + data.orderNumber + ' sicher erkannt. Für eine normale Rücksendung genügt der QR-Code aus Ihrer Versandmail; dieses Formular ist nur für einen freiwilligen Grund, eine Reklamation oder Fotos nötig.'
            : 'Bestellung gefunden. Bitte Positionen, Grund und — bei Bedarf — Foto prüfen und bestätigen.'
        );
      }
      selection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    lookup.addEventListener('submit', function (event) {
      event.preventDefault();
      var submit = lookup.querySelector('button[type="submit"]');
      submit.disabled = true;
      setStatus(status, '', 'Bestellung wird sicher geprüft …');
      var form = new FormData(lookup);
      api(root, {
        action: 'check',
        email: String(form.get('email') || ''),
        orderNumber: String(form.get('orderNumber') || ''),
      })
        .then(function (data) {
          showCheckedOrder(data, false);
        })
        .catch(function (error) {
          checkedOrder = null;
          selection.hidden = true;
          setStatus(status, 'err', error.message);
        })
        .finally(function () {
          submit.disabled = false;
        });
    });

    var secureAccess = String(query.get('returnAccess') || '').trim();
    var secureOrder = String(query.get('order') || '').trim();
    if (secureAccess && secureOrder) {
      query.delete('returnAccess');
      query.delete('email');
      var cleanQuery = query.toString();
      window.history.replaceState(
        null,
        document.title,
        window.location.pathname + (cleanQuery ? '?' + cleanQuery : '') + window.location.hash
      );
      lookup.hidden = true;
      setStatus(status, '', 'Ihre Bestellung wird über den sicheren E-Mail-Link erkannt …');
      api(root, {
        action: 'resume',
        orderNumber: secureOrder,
        returnAccess: secureAccess,
      })
        .then(function (data) {
          showCheckedOrder(data, true);
        })
        .catch(function (error) {
          checkedOrder = null;
          lookup.hidden = false;
          selection.hidden = true;
          setStatus(
            status,
            'err',
            error.message + ' Bitte prüfen Sie die Bestellung einmal manuell.'
          );
        });
    }

    // ISOLATION withdrawal-order-prefill
    // Bestellbestätigung „Kauf widerrufen“: ?order=&email= ohne returnAccess.
    // Bestellung wird geladen, der Kunde tippt nichts. E-Mail fliegt aus der sichtbaren URL.
    // Nicht entfernen. Nicht mit dem returnAccess-Block darüber (Versandmail) zusammenlegen.
    var prefillEmail = String(query.get('email') || '').trim();
    var prefillOrder = String(query.get('order') || '').trim();
    if (!secureAccess && prefillEmail && prefillOrder) {
      query.delete('email');
      var prefillQuery = query.toString();
      window.history.replaceState(
        null,
        document.title,
        window.location.pathname + (prefillQuery ? '?' + prefillQuery : '') + window.location.hash
      );
      lookup.hidden = true;
      setStatus(status, '', 'Ihre Bestellung wird geladen …');
      api(root, {
        action: 'check',
        email: prefillEmail,
        orderNumber: prefillOrder,
      })
        .then(function (data) {
          showCheckedOrder(data, true);
        })
        .catch(function (error) {
          checkedOrder = null;
          lookup.hidden = false;
          emailInput.value = prefillEmail;
          orderInput.value = prefillOrder;
          selection.hidden = true;
          setStatus(status, 'err', error.message);
        });
    }

    confirmForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!checkedOrder) return setStatus(status, 'err', 'Bitte Bestellung erneut prüfen.');
      var selected = Array.prototype.slice
        .call(linesBox.querySelectorAll('input[name="lineId"]:checked'))
        .map(function (input) {
          return input.value;
        });
      var form = new FormData(confirmForm);
      var customerName = String(form.get('customerName') || '').trim();
      var legalConfirmed = form.get('legalConfirmed') === 'yes';
      var automaticLabelTermsAccepted = form.get('automaticLabelTermsAccepted') === 'yes';
      var reasonId = selectedReasonId();
      var complaint = !!COMPLAINT_REASONS[reasonId];
      var unshipped = checkedOrder.shipmentState === 'unshipped';
      if (!selected.length) return setStatus(status, 'err', 'Bitte mindestens eine Position auswählen.');
      if (!reasonId) return setStatus(status, 'err', 'Bitte Widerruf oder Reklamationsgrund auswählen.');
      if (!customerName) return setStatus(status, 'err', 'Bitte Ihren Namen eingeben.');
      if (!legalConfirmed) return setStatus(status, 'err', 'Bitte bestätigen Sie Ihre Erklärung.');
      if (!complaint && !unshipped && !automaticLabelTermsAccepted) {
        return setStatus(
          status,
          'err',
          'Bitte bestätigen Sie die klar ausgewiesenen Bedingungen für das automatisch bereitgestellte DHL-Retourenlabel.'
        );
      }
      var submit = confirmForm.querySelector('button[type="submit"]');
      submit.disabled = true;
      setStatus(status, '', 'Widerruf wird verbindlich übermittelt …');

      var photoPromise = photoInput && photoInput.files && photoInput.files.length
        ? readPhotosAsBase64(photoInput.files)
        : Promise.resolve([]);

      photoPromise
        .then(function (photos) {
          return api(root, {
            action: 'confirm',
            email: checkedOrder.customerEmail,
            orderNumber: checkedOrder.orderNumber,
            token: checkedOrder.token,
            customerName: customerName,
            reasonId: reasonId,
            selectedLineIds: selected,
            automaticLabelTermsAccepted: automaticLabelTermsAccepted,
            photos: photos,
            declaration:
              'Hiermit widerrufe ich den Vertrag über die ausgewählten, widerrufsfähigen Positionen oder melde den ausgewählten Reklamationsgrund.',
          });
        })
        .then(function (data) {
          selection.hidden = true;
          lookup.hidden = true;
          confirmation.hidden = false;
          confirmation.textContent = '';
          confirmation.appendChild(
            el('h2', null, data.caseType === 'complaint' ? 'Reklamation eingegangen' : 'Widerruf eingegangen')
          );
          confirmation.appendChild(el('p', null, data.message));
          confirmation.appendChild(el('p', 'sawdr__reference', 'Vorgangsnummer: ' + data.withdrawalId));
          if (data.cashback && data.cashback.code) {
            confirmation.appendChild(
              el(
                'p',
                null,
                'Treue-Cashback: ' +
                  formatEuroFromCents(data.cashback.cashbackCents) +
                  ' · Code ' +
                  data.cashback.code
              )
            );
          }
          confirmation.appendChild(
            el('p', null, 'Eingang: ' + new Date(data.submittedAt).toLocaleString('de-DE'))
          );
          setStatus(status, 'ok', 'Eingangsbestätigung wurde per E-Mail versendet.');
          confirmation.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function (error) {
          if (error.data && error.data.withdrawalId) {
            setStatus(status, 'err', error.message + ' Vorgangsnummer: ' + error.data.withdrawalId);
          } else {
            setStatus(status, 'err', error.message);
          }
          submit.disabled = false;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-sawdr]');
    if (root) setup(root);
  });
})();
